(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2971],{

/***/ 59763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions",
      function () {
        return __webpack_require__(74745);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderBreadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs.js





// next

// @mui

// ----------------------------------------------------------------------
Breadcrumbs_Breadcrumbs.propTypes = {
    activeLast: (prop_types_default()).bool,
    links: (prop_types_default()).array.isRequired
};
function Breadcrumbs_Breadcrumbs(_param) {
    var links = _param.links, _activeLast = _param.activeLast, activeLast = _activeLast === void 0 ? false : _activeLast, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "activeLast"
    ]);
    var currentLink = links[links.length - 1].name;
    var listDefault = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
            link: link
        }, link.name);
    });
    var listActiveLast = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                marginBottom: 5
            },
            children: link.name !== currentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                link: link
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    maxWidth: 260,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    color: "text.disabled",
                    textOverflow: "ellipsis"
                },
                textTransform: "inherit",
                children: currentLink
            })
        }, link.name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled"
            }
        }),
        style: {
            alignItems: "center"
        }
    }, other), {
        children: activeLast ? listDefault : listActiveLast
    }));
}
// ----------------------------------------------------------------------
LinkItem.propTypes = {
    link: prop_types_default().shape({
        href: (prop_types_default()).string,
        icon: (prop_types_default()).any,
        name: (prop_types_default()).string
    })
};
function LinkItem(param) {
    var link = param.link;
    var _href = link.href, href = _href === void 0 ? "" : _href, name = link.name, icon = link.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            variant: "body2",
            sx: {
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                color: "grey.600",
                "& > div": {
                    display: "inherit"
                }
            },
            textTransform: "inherit",
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mr: 1,
                        "& svg": {
                            width: 20,
                            height: 20
                        }
                    },
                    children: icon
                }),
                name
            ]
        }, name)
    });
}

// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
;// CONCATENATED MODULE: ./src/components/HeaderBreadcrumbs.js





// @mui

//



// ----------------------------------------------------------------------
HeaderBreadcrumbs.propTypes = {
    links: (prop_types_default()).array,
    subtitle: (prop_types_default()).node,
    heading: (prop_types_default()).string.isRequired,
    moreLink: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array
    ]),
    sx: (prop_types_default()).object
};
function HeaderBreadcrumbs(_param) {
    var links = _param.links, subtitle = _param.subtitle, heading = _param.heading, _moreLink = _param.moreLink, moreLink = _moreLink === void 0 ?  false || [] : _moreLink, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "subtitle",
        "heading",
        "moreLink",
        "sx"
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({}, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, (0,_object_spread/* default */.Z)({
                        links: links
                    }, other)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    justifyContent: "flex-start"
                                },
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "fa-solid:arrow-left"
                                }),
                                onClick: function() {
                                    return router.back();
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "h1",
                                textTransform: "uppercase",
                                children: heading
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexShrink: 0,
                            pl: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: subtitle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: isString_default()(moreLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: moreLink,
                    target: "_blank",
                    variant: "body2",
                    children: moreLink
                }) : moreLink.map(function(href) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        noWrap: true,
                        href: href,
                        variant: "body2",
                        target: "_blank",
                        sx: {
                            display: "table"
                        },
                        children: href
                    }, href);
                })
            })
        ]
    });
}


/***/ }),

/***/ 74745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27948);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11496);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40571);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85307);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82771);
/* harmony import */ var _components_HeaderBreadcrumbs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(991);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9671);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76939);
/* harmony import */ var _sections_blog_question_QuestionSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95466);
// @mui





// layouts

// components

// sections




var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        paddingBottom: theme.spacing(10),
        paddingTop: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15)
    });
});
// ----------------------------------------------------------------------
Index.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
function Index() {
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().translate;
    var themeStretch = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().themeStretch;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: translate("question.title"),
        description: translate("question.description"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                maxWidth: themeStretch ? "xl" : "lg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HeaderBreadcrumbs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        heading: translate("question.title"),
                        links: [
                            {
                                name: translate("menu.home"),
                                href: _routes_paths__WEBPACK_IMPORTED_MODULE_6__/* .PATH_PAGE.home */ .ko.home
                            },
                            {
                                name: translate("menu.question"),
                                href: _routes_paths__WEBPACK_IMPORTED_MODULE_6__/* .PATH_RESOURCE.questions */ .U6.questions
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_blog_question_QuestionSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                ]
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,3362,917,2077,5410,6461,1739,892,9624,9352,3559,4397,2225,5250,5466,9774,2888,179], function() { return __webpack_exec__(59763); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);